export const API_KEY = script_global_vars.api_key;
export const HOST = script_global_vars.api_host;
export const DATES_INTERVAL = 15;